import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useAnalyticsMetricsByDay = (params = {}): UseQueryResult<any> => {
	return useQuery({
		queryKey: ['metrics-by-day', params],
		queryFn: async() => {
			const { data } = await axios.get('/analytics/metric-days', { params });
			return data;
		}
	});
};


